import React, { useState } from 'react';
import SurveysService from "../../../../services/SurveysService";
import {changeSurveyStatus, removeSurveyFromListById} from "../../../../slices/surveysSlice";
import DeleteSurveyModal from "../../modals/DeleteSurveyModal";
import {withToastManager} from "react-toast-notifications";
import {useDispatch} from "react-redux";


function SurveyRow(props){
    const dispatch = useDispatch();
    const {survey, numberOfRespondents} = props;
    const {questTitle, questStatus, dateOfCreation, lastModified} = survey;
    const [statusIsChanging, setStatusIsChanging] = useState(false);

    const [shouldShowDeleteModal, setShouldShowDeleteModal] = useState(false);
    const [isSurveyBeingDeleted, setIsSurveyBeingDeleted] = useState(false);

    const colActionsClassNameInactive = "surveys__list__table__item__col__actions";
    const colActionsClassNameActive = "surveys__list__table__item__col__actions surveys__list__table__item__col__actions--active"
    const [isActive, setActive] = useState(false);

    const actionText = questStatus === "ACTIVE" ? "Stop" : "Start";
    const actionClassName = "surveys__list__table__item__col__action surveys__list__table__item__col__action--" + actionText.toLowerCase();
    let statusClassName = "surveys__list__table__item surveys__list__table__item--draft";
    if(questStatus === "ACTIVE" || questStatus === "CLOSED") statusClassName = "surveys__list__table__item surveys__list__table__item--" + questStatus.toLowerCase();

    function gotToBuilderPage(){
        props.history.push("/survey/builder/" + props.survey.questId);
    }

    function goToChartsPage(){
        props.history.push("/survey/reports/" + survey.questId);
    }

    function goToSharePage(){
        props.history.push("/survey/share/" + survey.questId)
    }

    function handleClickChangeStatus(){
        if(statusIsChanging) return;
        const nextStatus = questStatus === "ACTIVE" ? "CLOSED" : "ACTIVE";
        setStatusIsChanging(true);
        SurveysService.ChangeSurveyStatus(props.survey.questId, nextStatus,
            (success1) => {
                dispatch(changeSurveyStatus({id:props.survey.questId,status:nextStatus}));
                setStatusIsChanging(false);
            },
            (error1) => {
                setStatusIsChanging(false);
            }
        );
    }

    function deleteSurvey(questId){

        setIsSurveyBeingDeleted(true);
        SurveysService.deleteSurveyById(questId,
            (success) => {
                setIsSurveyBeingDeleted(false);
                setShouldShowDeleteModal(false);
                dispatch(removeSurveyFromListById({questId : questId}));
            },
            (error) => {
                props.toastManager.add("Could not delete survey.", {
                    appearance: 'error'
                });
                setIsSurveyBeingDeleted(false);
                setShouldShowDeleteModal(false);
            }
        );
    }

    function openDeleteModal(){
        setShouldShowDeleteModal(true);
    }

    function closeDeleteModal(){
        setShouldShowDeleteModal(false);
    }

    return (
        <div className={statusClassName}>
            <div className="surveys__list__table__item__col">
                <div className="surveys__list__table__item__col__status">
                    <span className="surveys__list__table__item__col__status__bubble"></span>
                    <span className="surveys__list__table__item__col__status__text">{questStatus}</span>
                </div>
                <div className={isActive ? colActionsClassNameActive : colActionsClassNameInactive}>
                    <div className="surveys__list__table__item__col__actions__dots" onClick={() => {setActive(!isActive);}}>
                        <span></span> <span></span> <span></span>
                    </div>
                    <a className="surveys__list__table__item__col__actions__share" href="#" onClick={(event) => {event.preventDefault();goToSharePage()}}><img
                        src="./assets/img/surveys/launch.png" alt=""/>Share</a>
                    <a className="surveys__list__table__item__col__actions__reports" href="#" onClick={(event) => {event.preventDefault();goToChartsPage()}}><img
                        src="./assets/img/surveys/chart.png" alt=""/>Reports</a>
                    <a className="surveys__list__table__item__col__actions__delete" href="#" onClick={(event) => {event.preventDefault();openDeleteModal()}}><img
                        src="./assets/img/surveys/delete.png" alt=""/>Delete</a>
                </div>
            </div>
            <div className="surveys__list__table__item__col">
                <div className="surveys__list__table__item__col__title">{questTitle}<a
                     className="surveys__list__table__item__col__title__edit"
                     href="#" onClick={(event) => {event.preventDefault();gotToBuilderPage()}}><img
                    src="./assets/img/surveys/edit-blue.png" alt=""/></a></div>
            </div>
            <div className="surveys__list__table__item__col">
                <div className="surveys__list__table__item__col__respondents">{numberOfRespondents}</div>
            </div>
            <div className="surveys__list__table__item__col">
                <div className="surveys__list__table__item__col__created">{dateOfCreation}</div>
            </div>
            <div className="surveys__list__table__item__col">
                <div className="surveys__list__table__item__col__modified">{lastModified}</div>
            </div>
            <div className="surveys__list__table__item__col">
                <div
                    className={actionClassName}>
                    <a href="#" onClick={(event) => {event.preventDefault();handleClickChangeStatus();}}>
                        <span className="surveys__list__table__item__col__action__icon"></span>
                        <span className="surveys__list__table__item__col__action__text">{actionText}</span>
                    </a>
                </div>
            </div>
            <DeleteSurveyModal
                survey={props.survey}
                deleteSurvey={deleteSurvey}
                closeModal={closeDeleteModal}
                modalShown={shouldShowDeleteModal}
                isSurveyBeingDeleted={isSurveyBeingDeleted}
            />
        </div>
    );
}

export default withToastManager(SurveyRow);